/* eslint-disable */
import { App, ConfigProvider } from "antd";
import BluV2 from "./webparts/components/Blu";
import { RootStoreProvider } from "./webparts/components/RootStoreProvider";

const BLUAppComponent = () => {
  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Button: {
            borderRadius: 4,
            colorPrimary: "#5a7890",
            colorPrimaryHover: "rgba(47, 75, 98, 1)",
            colorPrimaryActive: "rgba(47, 75, 98, 1)",
            colorPrimaryTextActive: "#ffffff",
          },
          Typography: {
            fontSize: 16,
          },
        },
      }}
    >
      <App>
        <RootStoreProvider>
          <BluV2 />
        </RootStoreProvider>
      </App>
    </ConfigProvider>
  );
};

export default BLUAppComponent;